import { Drawer, DrawerProps } from '@mui/material'
import React from 'react'

export type WcDrawerProps = DrawerProps

export const WcDrawer = ({children, ...props}: WcDrawerProps) => (
    <Drawer {...props}>{children}</Drawer>
  )